export const messages = {
  en: {
    message: {
      value: "This is an example of content translation.",
      OrderDetails: "Next Order Details",
      OrderchangeDate: "Order can be changed by",
      OrderAmountBilled: "Amount to be billed",
      OderDeliverdate: "Next delivery expected on",
      ItemsIncluded: "Items included in your upcoming Order",
      DriverDetails: "Driver Van Detail",
      Location: "Location",
      Call: "Call",
      DriverPhone: "Driver Phone Number",
      Categories: "Categories",
      ContactUs: "Contact Us",
      OfficeAddress: "Locate Us",
      CallUs: "Office Number",
      ContactEmail: "Email Us",
      CallNow: "Call Now",
      VerifyNumber: "Verify Your Number",
      RegisterText:
        "We need to send you an OTP to verify your phone.",
      Submit: "Submit",
      NoOtp: "Didn’t receive the OTP?",
      ResendOtp: "Resend",
      Download:"Download",
      EnterNumber: "Enter Mobile Number",
      EditProfile: "Edit Profile",
      RegisterProfile: "Register Profile",
      Name: "Full Name",
      Email: "Email Address",
      Street: "Street (Optional)",
      HouseNumber: "Apartment Name/House No./Flat No.",
      City: "City",
      State: "State",
      Landmark: "Landmark",
      Nickname: "NICKNAME FOR ADDRESS",
      Proceed: "Proceed",
      Save: "Save",
      And:"And",
      NameValidation: "Name is required",
      HouseNumberValidation: "House number is required",
      CityValidation: "City is required",
      StateValidation: "State is required",
      EmailValidation: "Email is required",
      NicknameValidation: "Nickname is required",
      ValidEmail:"Needs to be a valid email",
      AddressValidation:"Please Select Addrress",
      QuantityValidation:"Please Select Quantity",
      Profile: "Profile",
      Edit: "Edit",
      Subscriptions: "Subscriptions",
      Subscription: "Subscription",
      Wallet: "Wallet",
      Money:"Money",
      Home: "Home",
      Search: "Search",
      Items: "Items",
      GetOnce: "Get Once",
      Subscribe: "Subscribe",
      OneTimeOrder: "One Time Order",
      ViewDetails: "View Details",
      Total: "Total Amount",
      SelectQuantity: "Select quantity",
      SelectOption: "Please select an option",
      MyOrder: "My Orders",
      Order: "Order",
      Id: "Id",
      Product: "Product",
      Price: "Price",
      Quantity: "Quantity",
      SubTotal: "Sub Total",
      OrderCancelConfirmation: "Are you sure you want to cancel this order?",
      YesButton: "Yes",
      NoButton: "No",
      Schedule: "Schedule",
      StartedDate: "Started on",
      EndDate: "Ends on",
      Status: "Status",
      SubscriptionNotFound: "No Subscription Found",
      OrderNotFound: "Orders Not Available",
      TransactionNotFound:"No Transactions",
      Available:"Available Balance",
      GuestUser: "Guest User",
      Balance: "Balance",
      SeeTransaction: "See your all transactions",
      PrivacyPolicy: "Privacy Policy",
      AboutUs: "About Us",
      TermsandConditions: "Terms and Conditions",
      RefundPolicy: "Refund Policies",
      MyProfile: "My Profile",
      Logout: "Logout",
      Login: "Login",
      LogoutConfirm: "Are you sure you want to Logout?",
      PhoneNumber: "Phone Number",
      NextDelivery: "Next Delivery On",
      PauseSubs: "Pause",
      PausedSubs: "Paused",
      CancelSubs: "Cancel",
      CancelledSubs: "Cancelled",
      Active: "Active",
      Resume: "Resume",
      PauseSubConfirm: "Do you want to pause the Subscription ?",
      CancelSubConfirm: "Do you want to cancel the Subscription ?",
      Address: "Address",
      Delivery:"Delivery",
      DelAddress:"Delivery Address",
      Date:"Date",
      Time:"Time",
      Charges:"Charges",
      AddAddress: "Add New Address",
      NextBtn: "Next",
      PhoneLengthErr: "Phone number should be",
      digits:"digits long.",
      onlyNumbers: "Only Numbers are allowed.",
      EnterPhoneNumber: "Enter phone number to continue.",
      Monday: "Monday",
      Tuesday: "Tuesday",
      Wednesday: "Wednesday",
      Thursday: "Thursday",
      Friday: "Friday",
      Saturday: "Saturday",
      Sunday: "Sunday",
      DateValidation:"Date field is empty.",
      Failed:"Failed",
      Success:"Success",
      Ok:"Ok"
    }
  },
  be: {
    message: {
      value: "Гэта прыклад перакладу змесціва.",
      Categories: "Катэгорыі"
    }
  },
  da: {
    message: {
      value: "Dette er et eksempel på oversættelse af indhold."
    }
  },
  hr: {
    message: {
      value: "Ovo je primjer prevođenja sadržaja."
    }
  }
};
